import { IError, IPaging, IResponse } from "@core/data-access/model";
import { AttributeValue } from "@modules/product/model/domain/attribute/AttributeValue";
import { Profile } from "@modules/product/model/domain/propertyModel/Profile";
import { ProfileModel } from "@modules/property-model/model/domain/ProfileModel";
import { PropertyModel } from "@modules/property-model/model/domain/PropertyModel";
import { AttrOption, ErrorMsg, SkuAttributeModel } from "@modules/property-model/model/domain/SkuAttributeModel";
import { ProductTypeEnum } from "../../../modules/product/model/dto/ProductTypeEnum";
import { IShipping } from "@modules/shipping/model/domain/shipping";
import { IShippingPriceItem } from "@modules/shipping/model/domain/shipping-price-item";
import { IProductPrice } from "@modules/product/model/domain/pricing/product-price";
import { IQtyShippingPriceTableItem } from "@modules/shipping/model/domain/qty-shipping-price-table-item";
import { ITurnaroundTime } from "@modules/shipping/model/domain/turnaround-time";
import { StoreType } from "@core/utils/config/website-stores.config";
import { WhiteLabelPriceTypeEnum } from "@modules/product/pricing/model/domain/WhiteLabelPriceTypeEnum";
import { IRestConfig } from "@components/discrete-price-list";

export class PropertyViewValue implements IPropertyViewValue {
    [profileId: string]: ProfileViewValue;
}

/**
 * @deprecated
 */
export interface IPropertyViewValue {
    [profileId: string]: ProfileViewValue;
}

/**
 * @deprecated
 */
export class ProfileViewValue {
    attributeList: {
        [attributeId: string]: SkuAttributeModelViewValue;
    } = {};
    profile: Profile;
}

/**
 * @deprecated
 */
export class SkuAttributeModelViewValue extends SkuAttributeModel {
    constructor(skuAttributeModel: SkuAttributeModel) {
        super();
        this.attributeId = skuAttributeModel.attributeId;
        this.defaultDisplayOptions = skuAttributeModel.defaultDisplayOptions;
        this.attrOptions = skuAttributeModel.attrOptions;
        this.defaultEnableOptions = skuAttributeModel.defaultEnableOptions;
        this.defaultHiddenOptions = skuAttributeModel.defaultHiddenOptions;
        this.defaultValue = skuAttributeModel.defaultValue;
        this.detail = skuAttributeModel.detail;
        this.displayAccuracy = skuAttributeModel.displayAccuracy;
        this.displayName = skuAttributeModel.displayName;
        this.enable = skuAttributeModel.enable;
        this.errorMsg = skuAttributeModel.errorMsg;
        this.groupId = skuAttributeModel.groupId;
        this.groupName = skuAttributeModel.groupName;
        this.hidden = skuAttributeModel.hidden;
        this.isDirty = skuAttributeModel.isDirty;
        this.isLegal = skuAttributeModel.isLegal;
        this.isSku = skuAttributeModel.isSku;
        this.placeHolder = skuAttributeModel.placeHolder;
        this.profileId = skuAttributeModel.profileId;
        this.readOnly = skuAttributeModel.readOnly;
        this.required = skuAttributeModel.required;
        this.saveAccuracy = skuAttributeModel.saveAccuracy;
        this.selectType = skuAttributeModel.selectType;
        this.skuAttributeId = skuAttributeModel.skuAttributeId;
        this.sortOrder = skuAttributeModel.sortOrder;
        this.value = skuAttributeModel.value;
        this.valueType = skuAttributeModel.valueType;
        this.options = {};
    }
    options: {
        [optionId: string]: OptionViewValue
    } = {};
    canSelect: boolean;
}

/**
 * @deprecated
 */
export class OptionViewValue extends AttrOption {
    constructor(attrOption: AttrOption) {
        super();
        this.displayValue = attrOption.displayValue;
        this.enable = attrOption.enable;
        this.hidden = attrOption.hidden;
        this.id = attrOption.id;
        this.isSelected = attrOption.isSelected;
        this.name = attrOption.name;
        this.sortOrder = attrOption.sortOrder;
        this.value = attrOption.value;
    }
    canSelect: boolean;
}



/**
 * @description 产品详情页Controller接口
 */
export interface IProductDetailController {
    state: IProductDetailState;
    qpLoading: qp.loading.IQpLoading;
    propertyService: IPropertyService;
    propertyViewValue: IPropertyViewValue;
    currentProductId: number;
    configurableProductId: number;
    rootPath: string;

    [prop: string]: any;

    // calculationPricing();

    onRequestFail(resp);

    propertyDomain: PropertyModel;
    cancelPropertyWatch();

    $scope: IPropertyDetailScope;
}

/**
 * @description 产品详情页Controller状态接口
 */
export interface IProductDetailState {
    isLogin: boolean;

    setContext(context: IProductDetailController): void;
    selectedStore(propertyModelId: number | undefined, storeId: string | undefined): void;
    // addProductToStore(storeIds: Array<string>, propertyModelId: number | undefined, currentProductId: number, rootPath: string):void;
}
export interface IProductPropertyViewValue {
    [proMap: string]: PropertyInfoViewValue | any;
}

export interface IbreadcrumbProduct {
    id: number;
    name: string;
    pagePath: string;
}

export class PropertyInfoViewValue {
    public hidden: boolean;
    public isSelected: boolean;
    public unable: boolean;
    public value: Array<number> | string | number
    public optionId: number;
    public isLegal: boolean;
    public errorMsg: ErrorMsg;
    public readOnly: boolean;
    public required: boolean;
}


/**
 * @description 属性策略接口
 */
export interface IPropertyService {
    // init(productId: number): angular.IPromise<qpmn.common.rest.IRestResponse<Array<qpmn.product.model.domain.propertyModel.IProfileModel>> | qpmn.common.rest.IRestResponse<Array<qpmn.product.model.domain.IAttributeValue>>>;

    getAllAttributeValue(context: IProductDetailController): angular.IPromise<IResponse<Array<AttributeValue>>>;

    save(attributeModel: qpmn.product.model.domain.propertyModel.IPropertyModel | Array<qpmn.product.model.domain.IAttributeValue>): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.product.model.domain.propertyModel.IPropertyModel>>;

    attributeCnversion(attributeModel: Array<qpmn.product.model.domain.propertyModel.IProfileModel> | Array<qpmn.product.model.domain.IAttributeValue>): Array<qpmn.product.model.domain.IAttributeValue>


    calculationAttribute(attributeModel: qpmn.product.model.domain.propertyModel.IPropertyModel | Array<qpmn.product.model.domain.IAttributeValue>, configurableProductId: number): angular.IPromise<qpmn.common.rest.IRestResponse<PropertyModel> | undefined>

    /**
     * @deprecated
     * @param propertyModel 
     */
    convertPropertyViewValueByModel(propertyModel: PropertyModel): PropertyViewValue;

    updateViewValue(pmViewValue: IProductPropertyViewValue, domain: PropertyModel, type: string): IProductPropertyViewValue;

    // **********************************

    /**
     * @description 通过属性model更新viewValue
     * @param propertyDomain 
     */
    updatePropertyViewValue(viewValue: IProductPropertyViewValue, propertyDomain: PropertyModel): IProductPropertyViewValue;

    /**
     * @description 创建属性的model值
     * @param currentProductId 
     * @param propertyModelId
     */

    getProductProperty(currentProductId: number, propertyModelId: number | undefined, attributeVersion: number | undefined): angular.IPromise<IResponse<PropertyModel | IError> | undefined>

    getAttributeValue(context: IProductDetailController): angular.IPromise<IResponse<Array<AttributeValue>>>;

    creatPropertyViewValue(domain: PropertyModel, type: string): IProductPropertyViewValue;
}


/**
 * @description 产品详情公用方法
 * */
export interface IProductDetailManager {
    setContext(context: IProductDetailController): void;

    checkUrlParams(): boolean;

    initObjectTree(): void;

    getDefaultProperty(productId: number): void;


    getBreadcrumbViewValue(productId: number): angular.IPromise<Array<IbreadcrumbProduct>>;

    creatAttributeSnapshot(attributeValues: Array<qpmn.product.model.domain.IAttributeValue>): ISnapshotObj;

    initObjectTree(): void;

    getDefaultProperty(productId: number): void;
}

/**
 * @description 产品属性更改后的处理策略:"CALCULATE" | "LINK";
 * CALCULATE:执行属性计算
 * LINK:执行页面跳转
 */
export type PropertyChangeStrategy = "CALCULATE" | "LINK";

/**
 * @description 获取WhitelabelProductId方法，返回数据类型定义
 */
export interface IWhitelabelProductIdResult {
    success: boolean;
    data: {
        whitelabelProductId: number
    }
}

/**
 * @description 获取StoreProductTypeList和当前产品类型方法，返回数据类型定义
 */
export class StoreProductTypeListResult {
    constructor(public currentProduct, public storeProductTypeList) {
        this.currentProduct = currentProduct;
        this.storeProductTypeList = storeProductTypeList
    }
    success: boolean;
}

export interface ICurrentProduct {
    productType: string;
    skuProductId: number;
    configurableProductId: number;
}
export interface IStoreProductType {
    name: string;
    value: string;
    description: string;
}


export class SkuStoreProductType implements IStoreProductType {
    name = "SKU WITHOUT DESIGN";
    value = "SKU";
    description = "Choose your product, select one SKU of this product, and let your customers to design it before adding to cart in your own shop.";
    fileName = "store-prodct-type_sku-1.png";
}
export class ConfigurableStoreProductType implements IStoreProductType {
    name = "full property without design";
    value = "CONFIGURABLE";
    description = "Multiple product attributes can be selected at the same time to add to the store product.";
    fileName = "store-prodct-type_configuable.png";
}
export class DesignStoreProductType implements IStoreProductType {
    name = "SKU WITH DESIGN";
    value = "DESIGN";
    description = "Choose your product, select one SKU of this product, customize it and make it into your creative product.";
    fileName = "store-prodct-type_design.png";
}


/**************************************** */

export interface IPropertyDetailScope extends angular.IScope {
    // 控制价格列表开启/关闭状态
    pricingIsOpen: boolean;
    propertyMap: IProductPropertyViewValue
    // 当前产品名称
    productName: string;
    // 货币
    symbol: string;
    currentProductId: string;

    isInternal: boolean;
    // 货币Code,记录当前使用的货币类型
    currencyCode: string;
    // profile标识
    profileKey: string;
    // 属性版本
    attributeVersion: number;
    // 属性发布ProfileCodes
    publishProfileCodes: Array<string>;
    // 属性发布ProfileIds
    publishProfileIds: Array<number>;
    cmsConfigVersion: number;
    publishAppTag: string;
    publishAppName: string;
    // 成品产品标识
    isFinished: boolean;

    /******************* */
    // 产品是否有MOQ配置
    hasMoq: boolean;
    moq: number;
    pricingSetting: {
        name: string;
        isoCode2: string;
    }
    // 属性表单类型
    formCode?: string;
    // 属性表单版本号
    attributeVersionNumber?: string;
    // 设计模式
    defaultDesignModel?: string;
    // 属性关联产品设计模式
    attributeRelationDesignMethod?: boolean;
    // 产品设计版本
    designMethodVersion: number;
    // 是否固定价格
    isFixedPrice: boolean;
    // 是否属性相关
    priceAffectedByAttribute: boolean;
    // 是否数量相关
    priceAffectedByQuantity: boolean;
    // 价格类型
    priceType: WhiteLabelPriceTypeEnum;
    // 离散价格范围
    discretePriceRange: Array<number>;
}

export interface IAuthorizedDetailScope extends IPropertyDetailScope {

}


/*************************** 预估运费ViewValue ***************************** */
//  SKU产品信息快照,通过 属性键值对 进行存储
export interface ISkuProductInfoCache {
    [propertysKey: string]: IProductSnapshot
}

//  SKU产品预估配送信息快照,通过 属性键值对+国家code+产品qty 进行存储
export interface ISkuCountryDeliveryCache {
    [attrsCountryCodeQtysKey: string]: ISkuDeliveryView;
}

// 预估配送信息-产品信息视图数据
export interface ISkuDeliveryView {
    product: IProductSnapshot;
    shippingMethods: Array<IDeliveryCostView>;
}

// 预估配送信息--视图数据记录（key）
export interface IDeliveryViewRecord {
    [propertysKey: string]: IDeliveryItemViewRecord;
}

export interface IDeliveryItemViewRecord {
    // string(propertysKey)
    product: string;
    // string(propertysKeyCountryCode)
    shippingMethod: Array<string>;
}

// SKU产品快照,通过propertyModelId进行绑定
export interface ISkuSnapshot {
    [snapshotKey: string]: IProductSnapshot;
}

export interface IProductSnapshot {
    name: string;
    property: string;
}

// SKU產品運費信息:Estimate
export interface ISkuDelivery {
    [snapshotKey: string]: Array<IDeliveryCost>;
}

export interface IShippingMethod {
    [snapshotKey: string]: Array<IShippingPriceItem>;
}


export interface IDeliveryCost {
    country: IDeliveryCountry;
    deliveries: Array<IDeliveryCostView>
}

export interface IDeliveryProduct {
    name: string;
    productAttributeValue: string;
}

// 国家名称对象
export interface IDeliveryCountry {
    code: string;
    displayName: string;
}

// 配送方式
export interface IDeliveryMethod {
    code: string;
    displayName: string;
    // 当前配送方式首重信息
    firstHeavy: IHeavyCost;
    overHeavy: Array<IHeavyCost>;
    //配送时间
    time: IDeliveryTimes;
}

interface IHeavyCost {
    // 产品可配送的最小数量
    minQty: number;
    // 产品可配送的最大数量
    maxQty?: number;
    // 价格
    price: string;
}

interface IDeliveryTimes {
    minDay: number;
    maxDay: number;
}

export interface IDeliveryInfoView {
    product: IProductSnapshot,
    countries: IDeliveryCost
}

// 预估配送费用请求对象
export interface ISearchShippingRequestObj {
    delivery?: angular.IPromise<IResponse<IShipping>>
}
// 预估配送费用初始化请求对象
export interface ShippingInitRequestObj {
    delivery?: angular.IPromise<IDeliveryCost>
    countries?: angular.IPromise<IResponse<qpmn.common.rest.IPaging<qpmn.user.model.domain.area.ICountryContent>>>
}

// 产品属性对象
export interface ISnapshotObj {
    [attributeId: string]: string | Array<number>;
}

/************************  Chore  *****************************/
export interface IOperationStatus {
    // 是否在执行
    updateQty?: boolean;
}

export interface IProductKeyValue {
    attributeId: number;
    optionIds: string;
    value: string;
}

export interface IPropertyKey {
    value: string | number | Array<number> | null;
    attributeId: number;
}
export interface ISkuPropertyCodeKey {
    value: string | number | Array<number | string> | null;
    skuAttributeCode: string;
}


// 产品计价列表视图数据
export interface IBulkPriceViewValue {
    defaultCurrency: Array<IPriceItemViewValue>;
    userCurrency: Array<IPriceItemViewValue>;
}

export interface IPriceItemViewValue extends IProductPrice {
    qtyInterval?: string;
}

export interface IDeliveryCostView {
    deliveryMethod: string;
    country: string;
    countryName: string;
    // 国家名称显示状态（countryName）
    isShow: boolean;
    rowspan?: number;
    qtyPrice1?: IQtyPrice;
    qtyPrice2?: IQtyPrice;
    qtyPrice3?: IQtyPrice;
    qtyPrice4?: IQtyPrice;
    qtyPrice5?: IQtyPrice;
    custonQtyPrice?: IQtyPrice;
    turnaroundTime?: ITurnaroundTime;
    shippingTimeInfo?: string;
}
export interface IQtyPrice {
    value: string | null;
    tip?: string;
}

export interface IDeliveryQtyPriceObj {
    qtyPrice1?: string;
    qtyPrice2?: string;
    qtyPrice3?: string;
    qtyPrice4?: string;
    qtyPrice5?: string;
    custonQtyPrice?: string;
}

// 产品描述区域（product-info）信息展示状态
export interface IProductInfoViewValue {
    // 产品描述信息
    descIsOpen?: boolean;
    // 产品配送信息
    shippingIsOpen?: boolean;
    // 产品规格
    specificationsIsOpen?: boolean;
    // wooCommerece插件
    wooPluginIsOpen?: boolean;
    // nap-shop
    unsupported?: boolean;
    // api-integration
    apiIntegrationIsOpen?: boolean;
}

// 页面地址参数
export class PageUrlParams {
    storeId?: string;
    pid?: string;
    type?: string;
    storeType?: string;
    storeProductId?: string;
    storeName?: string;
    storeUrl?: string;
    propertyModelId?: string;
    // 页面锚点
    anchor?: string;
    // 是否为dashboard访问页面
    isinline?: boolean;
    // 产品设计模式
    designMode?: string;
}


export class StoreInfo {
    platform: StoreType;
    id: string;
}

export class IDesignModelOptionViewValue {
    code: string;
    name: string;
}

export enum DiscretePriceEventName {
    ProductAttrChange = "PRODUCT_ATTR_CHANGE",
    CurrencyChange = "CURRENCY_CHANGE",
    InquiryPriceChange = "INQUIRY_PRICE_CHANGE",
}

import { InquiryPrice } from "@components/inquiry-price";

export interface IDiscretePriceParams {
    qtyList?: Array<number>;//默认离散计价数量列表
    customSize?: number;//自定义数量个数
    productChangeEventName?: string;//属性变更引起产品Id变化监听事件名
    attrChangeEventName?: string;//属性变更监听事件名
    qtyChangeEventName?: string;//数量变更监听事件名
    currencyChangeEventName?: string;//货币变更监听事件名
    restConfig?: IRestConfig;//离散计价表接口配置
    fixedPrice: boolean;//是否是固定计价
    needChangedWhenAttrs: boolean;//属性是否影响计价
    needChangedWhenQty: boolean;//刷量是否影响计价
    attrKeys?: Array<AttributeValue>;//属性键值对
    inquiryPrice?: InquiryPrice;//产品询价数据
}

export enum ChangeType {
    Attr = "Attr",
    Qty = "Qty"
}
